<div id="top" class="pr-public-page">
  <div class="detail-back-wrap pt-3 mb-5">
    @if (isPreview) {
      <button type="button" class="detail-back float-end" (click)="closePreview()">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.7"><line x1="4" y1="4" x2="12" y2="12"/><line x1="12" y1="4" x2="4" y2="12"/></svg>
        ปิด
      </button>
    } @else {
      <a class="detail-back float-end" [routerLink]="basePath">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.7"><polyline points="9,3 4,8 9,13"/><line x1="4" y1="8" x2="13" y2="8"/></svg>
        ย้อนกลับ
      </a>
    }
  </div>
  @if (isLoading) {
    <div class="detail-content">
      <section class="acfs">
        <div class="skeleton-shell" aria-hidden="true">
          <div class="content-card skeleton-card">
            <div class="skeleton-head">
              <div class="skeleton-copy">
                <div class="skeleton-box skeleton-line lg" style="width: 72%"></div>
                <div class="skeleton-box skeleton-line" style="width: 40%"></div>
                <div class="skeleton-box skeleton-line" style="width: 92%"></div>
                <div class="skeleton-box skeleton-line" style="width: 84%"></div>
                <div class="skeleton-box skeleton-line" style="width: 55%"></div>
              </div>
              <div class="skeleton-box skeleton-cover"></div>
            </div>
          </div>
          <div class="content-card skeleton-card">
            <div class="skeleton-box skeleton-line lg" style="width: 32%"></div>
            <div class="skeleton-cert-list">
              @for (i of skeletonItems; track i) {
                <div class="skeleton-box skeleton-cert"></div>
              }
            </div>
          </div>
        </div>
      </section>
    </div>
  } @else if (notFound || !page) {
    <div class="public-state">
      <h2>ไม่พบเพจประชาสัมพันธ์</h2>
      <p>ตรวจสอบลิงก์อีกครั้ง หรือกลับไปยังระบบจัดการเพจประชาสัมพันธ์</p>
      <a class="btn btn-outline-primary" routerLink="/pr/pages">กลับไปหน้าจัดการ</a>
    </div>
  } @else {
    <div class="detail-content">
      @if (isTemplateTwo) {
        <section class="acfs acfs-template-two">
          <div class="template-two-shell">
            <div class="template-two-main content-card">
              <div class="template-two-head">
                <div class="template-two-copy">
                  <h1>{{ page.pageName || '-' }}</h1>
                  @if (updatedDateLabel) {
                    <div class="created-date">{{ updatedDateLabel }}</div>
                  }
                  @if (page.productName) {
                    <p class="acfs-subtitle">{{ page.productName }}</p>
                  }
                  @if (page.pateType) {
                    <p class="acfs-business-detail">{{ page.pateType }}</p>
                  }

                  @if (hasContactInfo) {
                    <div class="contact-actions">
                      <button type="button" class="contact-info-button" (click)="openContactModal()">
                        <i class="bi bi-person-lines-fill" aria-hidden="true"></i>
                        ข้อมูลการติดต่อ
                      </button>
                    </div>
                  }

                  @if (showComments || tags.length > 0 || createdDateLabel) {
                    <div class="acfs-stats">
                      @if (showComments) {
                        <div class="rating-summary">
                          <div class="stars" [attr.aria-label]="'คะแนนเฉลี่ย ' + averageScore.toFixed(1) + ' จาก 5'">
                            @for (star of scoreOptions; track star) {
                              <span [class.active]="star <= averageScore">★</span>
                            }
                          </div>
                          <span class="rating-text">
                            {{ averageScore ? averageScore.toFixed(1) : '0.0' }}/5
                            ({{ comments.length }} ความคิดเห็น)
                          </span>
                        </div>
                      }
                      <div class="acfs-stat-line">
                        @if (tags.length > 0) {
                          <div class="tag-line">
                            <span class="tag-line-label">
                              <i class="bi bi-tags-fill" aria-hidden="true"></i>
                              <span>แท็ก</span>
                            </span>
                            @for (tag of tags; track tag) {
                              <span class="tag">{{ tag }}</span>
                            }
                          </div>
                        }
                        <div class="acfs-stat-right">
                          @if (showComments) {
                            <div class="view-summaryx" [attr.aria-label]="'จำนวนการเข้าชม ' + (page.viewCount || 0)">
                              <app-search-icon [size]="16" classList="view-icon me-2"></app-search-icon>
                              <span>{{ page.viewCount || 0 }}</span>
                            </div>
                          }
                          @if (createdDateLabel) {
                            <div class="created-date created-date-inline">{{ createdDateLabel }}</div>
                          }
                        </div>
                      </div>
                    </div>
                  }

                </div>

                <div class="template-two-cover">
                  <div class="template-two-cover-frame">
                    @if (page.coverPath) {
                      <img [src]="page.coverPath" [alt]="page.pageName || 'cover'" class="cover-image">
                    } @else {
                      <div class="cover-placeholder">ACFS PR</div>
                    }
                  </div>
                </div>
              </div>

              @if (page.showAlbum === 1 && (page.albumPaths?.length || 0) > 0) {
                <div class="template-two-album">
                  <div class="section-head">
                    <div>
                      <h2>ภาพสินค้า</h2>
                    </div>
                  </div>
                  <div class="public-album-grid">
                    @for (path of albumPaths; track path) {
                      <button type="button" class="public-album-card" (click)="openAlbumImage(path)">
                        <img [src]="path" alt="ภาพสินค้า" class="public-album-image">
                      </button>
                    }
                  </div>
                </div>
              }
            </div>

            @if (certificationDetails.length > 0) {
              <div class="content-card template-two-certifications">
                <div class="section-head">
                  <div>
                    <h2>ข้อมูลใบรับรอง</h2>
                    <p>กดที่แต่ละรายการเพื่อดูรายละเอียดใบรับรองที่เกี่ยวข้อง</p>
                  </div>
                  <div class="section-actions" [class.d-none]="certificationDetails.length <= 1">
                    @if (certificationViewMode === 'row') {
                      <div class="certification-bulk-actions">
                        <button type="button" class="bulk-action-button" (click)="expandAllCertificationDetails()">
                          ขยายทั้งหมด
                        </button>
                        <button type="button" class="bulk-action-button" (click)="collapseAllCertificationDetails()">
                          ปิดทั้งหมด
                        </button>
                      </div>
                    }
                    <div class="view-toggle" role="group" aria-label="รูปแบบการแสดงข้อมูลใบรับรอง">
                      <button
                        type="button"
                        class="view-toggle-button"
                        [class.active]="certificationViewMode === 'grid'"
                        (click)="setCertificationViewMode('grid')"
                        aria-label="แสดงแบบตาราง">
                        <i class="bi bi-grid-3x3-gap-fill" aria-hidden="true"></i>
                      </button>
                      <button
                        type="button"
                        class="view-toggle-button"
                        [class.active]="certificationViewMode === 'row'"
                        (click)="setCertificationViewMode('row')"
                        aria-label="แสดงแบบแถว">
                        <i class="bi bi-view-stacked" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="certificate-list" [class.row-view]="certificationViewMode === 'row'">
                  @for (detail of certificationDetails; track detail.id ?? $index) {
                    <article class="certificate-item" [class.expanded]="isCertificationExpanded(detail)"
                             [class.row-item]="certificationViewMode === 'row'">
                      <button type="button" class="certificate-toggle" (click)="toggleCertification(detail)">
                        <div class="certificate-badge">
                          <img [appStandardMark]="detail.standardCode" alt="Q Mark" class="certificate-badge-image">
                        </div>
                        <div class="certificate-summary">
                          <h3>กษ {{ detail.uniqCode || '-' }}</h3>
                          <p>{{ detail.productName || '-' }}</p>
                        </div>
                        @if (certificationViewMode === 'row') {
                          <span class="certificate-icon">{{ isCertificationExpanded(detail) ? '−' : '+' }}</span>
                        }
                      </button>

                      @if (isCertificationExpanded(detail)) {
                        <div class="certificate-body">
                          <div class="certificate-meta-grid">
                            <div>
                              <span>ผู้ให้การรับรอง</span>
                              <strong>{{ detail.departmentCodeall || '-' }}</strong>
                            </div>
                            <div>
                              <span>มาตรฐาน</span>
                              <strong>{{ detail.standardName || '-' }}</strong>
                            </div>
                            <div>
                              <span>ผู้ขอรับรอง</span>
                              <strong>{{ detail.farmerName || '-' }}</strong>
                            </div>
                            <div>
                              <span>ชนิดสินค้า</span>
                              <strong>{{ detail.productName || '-' }}</strong>
                            </div>
                            <div>
                              <span>เลขที่ใบรับรอง</span>
                              <strong>{{ detail.certificate || '-' }}</strong>
                            </div>
                            <div>
                              <span>ขอบข่าย</span>
                              <strong>{{ detail.scope || '-' }}</strong>
                            </div>
                            <div>
                              <span>ที่อยู่ผู้ขอรับรอง</span>
                              <strong>{{ detail.farmerAddressFull || detail.farmerAddress || '-' }}</strong>
                            </div>
                            <div>
                              <span>ที่ตั้งสถานที่ผลิต</span>
                              <strong>{{ detail.farmAddressFull || detail.farmName || '-' }}</strong>
                            </div>
                            <div>
                              <span>วันที่มีผล</span>
                              <strong>{{ detail.cerStartdate | date:'d MMM y' }}
                                - {{ detail.cerEnddate | date:'d MMM y' }}</strong>
                            </div>
                          </div>
                        </div>
                      }
                    </article>
                  }
                </div>
              </div>
            }
          </div>
        </section>
      } @else {
        <section class="acfs acfs-template-one">
          <div class="template-one-shell">
            <div class="template-one-main content-card">
              <div class="template-one-head">
                <div class="template-one-cover">
                  <div class="template-one-cover-frame">
                    @if (page.coverPath) {
                      <img [src]="page.coverPath" [alt]="page.pageName || 'cover'" class="cover-image">
                    } @else {
                      <div class="cover-placeholder">ACFS PR</div>
                    }
                  </div>
                </div>
                <div class="template-one-copy">
                  <h1>{{ page.pageName || '-' }}</h1>
                  @if (updatedDateLabel) {
                    <div class="created-date">{{ updatedDateLabel }}</div>
                  }
                  @if (page.productName) {
                    <p class="acfs-subtitle">{{ page.productName }}</p>
                  }
                  @if (page.pateType) {
                    <p class="acfs-business-detail">{{ page.pateType }}</p>
                  }

                  @if (hasContactInfo) {
                    <div class="contact-actions">
                      <button type="button" class="contact-info-button" (click)="openContactModal()">
                        <i class="bi bi-person-lines-fill" aria-hidden="true"></i>
                        ข้อมูลการติดต่อ
                      </button>
                    </div>
                  }

                  @if (showComments || tags.length > 0 || createdDateLabel) {
                    <div class="acfs-stats">
                      @if (showComments) {
                        <div class="rating-summary">
                          <div class="stars" [attr.aria-label]="'คะแนนเฉลี่ย ' + averageScore.toFixed(1) + ' จาก 5'">
                            @for (star of scoreOptions; track star) {
                              <span [class.active]="star <= averageScore">★</span>
                            }
                          </div>
                          <span class="rating-text">
                          {{ averageScore ? averageScore.toFixed(1) : '0.0' }}/5
                          ({{ comments.length }} ความคิดเห็น)
                        </span>
                        </div>
                      }
<div class="acfs-stat-line-inline">
                        @if (tags.length > 0) {
                          <div class="tag-line">
                          <span class="tag-line-label">
                            <i class="bi bi-tags-fill" aria-hidden="true"></i>
                            <span>แท็ก</span>
                          </span>
                            @for (tag of tags; track tag) {
                              <span class="tag">{{ tag }}</span>
                            }
                          </div>
                        }
                        <div class="acfs-stat-right">
                          @if (showComments) {
                            <div class="view-summaryx" [attr.aria-label]="'จำนวนการเข้าชม ' + (page.viewCount || 0)">
                              <app-search-icon [size]="16" classList="view-icon me-2"></app-search-icon>
                              <span>{{ page.viewCount || 0 }}</span>
                            </div>
                          }
                          @if (createdDateLabel) {
                            <div class="created-date created-date-inline">{{ createdDateLabel }}</div>
                          }
                        </div>
                      </div>
                    </div>
                  }

                </div>
              </div>

              @if (page.showAlbum === 1 && (page.albumPaths?.length || 0) > 0) {
                <div class="template-one-album">
                  <div class="section-head">
                    <div>
                      <h2>ภาพสินค้า</h2>
                    </div>
                  </div>
                  <div class="public-album-grid">
                    @for (path of albumPaths; track path) {
                      <button type="button" class="public-album-card" (click)="openAlbumImage(path)">
                        <img [src]="path" alt="ภาพสินค้า" class="public-album-image">
                      </button>
                    }
                  </div>
                </div>
              }
            </div>

            @if (certificationDetails.length > 0) {
              <div class="content-card template-one-certifications">
                <div class="section-head">
                  <div>
                    <h2>ข้อมูลใบรับรอง</h2>
                    <p>กดที่แต่ละรายการเพื่อดูรายละเอียดใบรับรองที่เกี่ยวข้อง</p>
                  </div>
                  <div class="section-actions" [class.d-none]="certificationDetails.length <= 1">
                    @if (certificationViewMode === 'row') {
                      <div class="certification-bulk-actions">
                        <button type="button" class="bulk-action-button" (click)="expandAllCertificationDetails()">
                          ขยายทั้งหมด
                        </button>
                        <button type="button" class="bulk-action-button" (click)="collapseAllCertificationDetails()">
                          ปิดทั้งหมด
                        </button>
                      </div>
                    }
                    <div class="view-toggle" role="group" aria-label="รูปแบบการแสดงข้อมูลใบรับรอง">
                      <button
                        type="button"
                        class="view-toggle-button"
                        [class.active]="certificationViewMode === 'grid'"
                        (click)="setCertificationViewMode('grid')"
                        aria-label="แสดงแบบตาราง">
                        <i class="bi bi-grid-3x3-gap-fill" aria-hidden="true"></i>
                      </button>
                      <button
                        type="button"
                        class="view-toggle-button"
                        [class.active]="certificationViewMode === 'row'"
                        (click)="setCertificationViewMode('row')"
                        aria-label="แสดงแบบแถว">
                        <i class="bi bi-view-stacked" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="certificate-list" [class.row-view]="certificationViewMode === 'row'">
                  @for (detail of certificationDetails; track detail.id ?? $index) {
                    <article class="certificate-item" [class.expanded]="isCertificationExpanded(detail)"
                             [class.row-item]="certificationViewMode === 'row'">
                      <button type="button" class="certificate-toggle" (click)="toggleCertification(detail)">
                        <div class="certificate-badge">
                          <img [appStandardMark]="detail.standardCode" alt="Q Mark" class="certificate-badge-image">
                        </div>
                        <div class="certificate-summary">
                          <h3>กษ {{ detail.uniqCode || '-' }}</h3>
                          <p>{{ detail.productName || '-' }}</p>
                        </div>
                        @if (certificationViewMode === 'row') {
                          <span class="certificate-icon">{{ isCertificationExpanded(detail) ? '−' : '+' }}</span>
                        }
                      </button>

                      @if (isCertificationExpanded(detail)) {
                        <div class="certificate-body">
                          <div class="certificate-meta-grid">
                            <div>
                              <span>ผู้ให้การรับรอง</span>
                              <strong>{{ detail.departmentCodeall || '-' }}</strong>
                            </div>
                            <div>
                              <span>มาตรฐาน</span>
                              <strong>{{ detail.standardName || '-' }}</strong>
                            </div>
                            <div>
                              <span>ผู้ขอรับรอง</span>
                              <strong>{{ detail.farmerName || '-' }}</strong>
                            </div>
                            <div>
                              <span>ชนิดสินค้า</span>
                              <strong>{{ detail.productName || '-' }}</strong>
                            </div>
                            <div>
                              <span>เลขที่ใบรับรอง</span>
                              <strong>{{ detail.certificate || '-' }}</strong>
                            </div>
                            <div>
                              <span>ขอบข่าย</span>
                              <strong>{{ detail.scope || '-' }}</strong>
                            </div>
                            <div>
                              <span>ที่อยู่ผู้ขอรับรอง</span>
                              <strong>{{ detail.farmerAddressFull || detail.farmerAddress || '-' }}</strong>
                            </div>
                            <div>
                              <span>ที่ตั้งสถานที่ผลิต</span>
                              <strong>{{ detail.farmAddressFull || detail.farmName || '-' }}</strong>
                            </div>
                            <div>
                              <span>วันที่มีผล</span>
                              <strong>{{ detail.cerStartdate | date:'d MMM y' }}
                                - {{ detail.cerEnddate | date:'d MMM y' }}</strong>
                            </div>
                          </div>
                        </div>
                      }
                    </article>
                  }
                </div>
              </div>
            }
          </div>
        </section>
      }

      @if (showComments) {
        <section class="comment-section">
          <div class="content-card comment-card comment-list-card">
            <div class="comment-header">
              <div>
                <h2>ความคิดเห็นทั้งหมด ({{ comments.length }})</h2>
                <p>ความคิดเห็นจากผู้เข้าชมเพจนี้</p>
              </div>
            </div>

            <div class="comment-list">
              @if (comments.length === 0) {
                <div class="empty-comments">ยังไม่มีความคิดเห็น</div>
              } @else {
                @for (comment of visibleComments; track comment.id ?? $index) {
                  <article class="comment-item">
                    <div class="comment-meta">
                      <strong>{{ comment.name || 'ผู้ใช้งานทั่วไป' }}</strong>
                      <span>{{ comment.createdDate | date:'d MMM y เวลา HH:mm' }}</span>
                    </div>
                    <div class="stars compact">
                      @for (star of scoreOptions; track star) {
                        <span [class.active]="star <= (comment.score ?? 0)">★</span>
                      }
                    </div>
                    <p>{{ comment.comment || '-' }}</p>
                  </article>
                }
              }
            </div>

            @if (hasMoreComments) {
              <button type="button" class="comment-load-more" (click)="loadMoreComments()">
                โหลดเพิ่มเติม
              </button>
            }
          </div>

          <div class="content-card comment-card comment-form-card">
            <div class="comment-header">
              <div>
                <h2>ความคิดเห็น</h2>
                <p>ให้คะแนนและฝากข้อความถึงเพจนี้ได้จากฟอร์มด้านล่าง</p>
              </div>
            </div>

            <form class="comment-form" [formGroup]="commentForm" (ngSubmit)="submitComment()">
              <div class="form-row score-row" [class.invalid]="isFieldInvalid('score')">
                <label>ระดับความคิดเห็น <span class="required-mark">*</span></label>
                <div class="score-picker">
                  @for (score of scoreOptions; track score) {
                    <button
                      type="button"
                      class="star-button"
                      [class.active]="score <= commentForm.get('score')!.value"
                      (click)="commentForm.get('score')!.setValue(score)">
                      ★
                    </button>
                  }
                </div>
                @if (getFieldError('score')) {
                  <div class="field-error">{{ getFieldError('score') }}</div>
                }
              </div>

              <div class="form-row" [class.invalid]="isFieldInvalid('name')">
                <label for="comment-name">ชื่อและนามสกุล <span class="required-mark">*</span></label>
                <input id="comment-name" type="text" class="form-control" [class.is-invalid]="isFieldInvalid('name')"
                       formControlName="name">
                @if (getFieldError('name')) {
                  <div class="field-error">{{ getFieldError('name') }}</div>
                }
              </div>

              <div class="form-row" [class.invalid]="isFieldInvalid('email')">
                <label for="comment-email">E-Mail <span class="required-mark">*</span></label>
                <input id="comment-email" type="email" class="form-control"
                       [class.is-invalid]="isFieldInvalid('email')" formControlName="email">
                @if (getFieldError('email')) {
                  <div class="field-error">{{ getFieldError('email') }}</div>
                }
              </div>

              <div class="form-row" [class.invalid]="isFieldInvalid('comment')">
                <label for="comment-message">ความคิดเห็น <span class="required-mark">*</span></label>
                <textarea id="comment-message" rows="4" class="form-control"
                          [class.is-invalid]="isFieldInvalid('comment')" formControlName="comment"></textarea>
                @if (getFieldError('comment')) {
                  <div class="field-error">{{ getFieldError('comment') }}</div>
                }
              </div>

              @if (submitError) {
                <div class="feedback error">{{ submitError }}</div>
              }
              @if (commentSaved) {
                <div class="feedback success">บันทึกความคิดเห็นเรียบร้อยแล้ว</div>
              }

              <div class="form-actions">
                <button type="submit" class="btn btn-primary" [disabled]="isSubmittingComment">
                  {{ isSubmittingComment ? 'กำลังบันทึก...' : 'แสดงความคิดเห็น' }}
                </button>
              </div>
            </form>
          </div>
        </section>
      }
    </div>
  }

  <ng-template #contactModalTpl let-modal>
    <div class="contact-modal-shell">
      <button type="button" class="contact-modal-close" aria-label="ปิด" (click)="modal.close()">
        <i class="bi bi-x-lg" aria-hidden="true"></i>
      </button>

      <div class="contact-modal-hero">
        <div class="contact-modal-badge" aria-hidden="true">
          <i class="bi bi-person-lines-fill"></i>
        </div>
        <div class="contact-modal-copy">
          <div class="contact-modal-kicker">ข้อมูลการติดต่อ</div>
          <h5>{{ page?.pageName || '-' }}</h5>
        </div>
      </div>

      <div class="contact-modal-body">
        <div class="contact-modal-grid">
          @for (item of contactInfoItems; track item.key) {
            <div class="contact-modal-item" [class.full-width]="item.key === 'address'" [class.hidden]="item.hidden">
              <div class="contact-modal-item__icon" aria-hidden="true">
                <i class="bi" [ngClass]="item.icon"></i>
              </div>
              <div class="contact-modal-item__content">
                <span class="contact-modal-item__label">{{ item.label }}</span>
                @if (item.href) {
                  <a class="contact-modal-item__value" [href]="item.href" target="_blank" rel="noopener">{{ item.value }}</a>
                } @else {
                  <strong class="contact-modal-item__value">{{ item.value }}</strong>
                }
              </div>
            </div>
          }
        </div>

        <div class="contact-modal-actions">
          @if (contactTelUrl) {
            <a class="contact-modal-action" [href]="contactTelUrl">
              <i class="bi bi-telephone-fill" aria-hidden="true"></i>
              โทรหา
            </a>
          }
          @if (contactEmailUrl) {
            <a class="contact-modal-action" [href]="contactEmailUrl">
              <i class="bi bi-envelope-fill" aria-hidden="true"></i>
              ส่งอีเมล
            </a>
          }
          @if (googleMapUrl) {
            <a class="contact-modal-action primary" [href]="googleMapUrl" target="_blank" rel="noopener">
              <i class="bi bi-geo-alt-fill" aria-hidden="true"></i>
              เปิดแผนที่
            </a>
          }
        </div>
      </div>
    </div>
  </ng-template>

  @if (selectedAlbumImage) {
    <div class="album-lightbox" (click)="closeAlbumImage()">
      @if (albumPaths.length > 1) {
        <button
          type="button"
          class="album-lightbox-nav album-lightbox-prev"
          aria-label="ภาพก่อนหน้า"
          (click)="showPreviousAlbumImage(); $event.stopPropagation()">
          <i class="bi bi-chevron-left"></i>
        </button>
        <button
          type="button"
          class="album-lightbox-nav album-lightbox-next"
          aria-label="ภาพถัดไป"
          (click)="showNextAlbumImage(); $event.stopPropagation()">
          <i class="bi bi-chevron-right"></i>
        </button>
      }
      <button type="button" class="album-lightbox-close" (click)="closeAlbumImage(); $event.stopPropagation()">
        <i class="bi bi-x-lg"></i>
      </button>
      <img [src]="selectedAlbumImage" alt="ภาพสินค้าแบบขยาย" class="album-lightbox-image"
           (click)="$event.stopPropagation()">
    </div>
  }
</div>
